import { LogoutIcon } from '@braskai/icons';
import { IconButton } from '@braskai/ui-kit';

import { Stack } from '@mui/material';

import { Avatar } from '../Avatar';
import { SCard, STextContainer, STypography } from './styled';

type ProfileProps = {
  active?: boolean;
  cursor?: 'default' | 'pointer';
  email?: string;
  picture?: string;
  planName?: string;
  variant?: 'filled' | 'outlined';
  handleLogout?: () => void;
  onClick?: () => void;
};

export const Profile = ({
  active = false,
  cursor = 'pointer',
  email,
  picture,
  planName,
  variant = 'filled',
  handleLogout,
  onClick,
}: ProfileProps) => {
  return (
    <SCard $active={active} $cursor={cursor} $variant={variant} aria-label="profile" data-testid="profile" role="button" onClick={onClick}>
      <Avatar alt="Profile image" src={picture} sx={{ height: 36, width: 36 }} />
      <STextContainer>
        <Stack alignItems="center" direction="row" justifyContent="space-between">
          <STypography title={planName} color="grey.900" variant="body-2-md">
            {planName}
          </STypography>
          {handleLogout && (
            <IconButton data-testid="profile-logout" disableBackground disableFixSizeIcon onClick={handleLogout}>
              <LogoutIcon height={20} width={20} />
            </IconButton>
          )}
        </Stack>

        <STypography title={email} color="grey.500" variant="caption-1-md">
          {email}
        </STypography>
      </STextContainer>
    </SCard>
  );
};
